import breadcrumbComp from "../../common/breadcrumb-comp";
import issueService from "./report-service.js";
import EncryptUtility from "../../utility/js/encrypt-utility";
import Utility from "../../../shared/utility.js";
import DisplayTextData from "../../common/display-text-data.vue";
import FeedbackForm from "@/components/common/feedback-comp.vue";
export default {
  data() {
    return {
      issueId: "",
      backSlash: true,
      showDeleteDialog: false,
      customPage: true,
      file: "",
      files: "",
      fileList: [],
      noFiles: true,
      refresh: true,
      dragging: false,
      showFeedbackForm: false,
      images: [],
      userId: EncryptUtility.localStorageDecrypt("userID"),
      searchBugs: "",
      bugDialog: false,
      issueTitle: "",
      issueDescription: "",
      uploadFileName: "",
      url: "",
      isFormValid: false,
      bugData: [],
      totalRecords: 0,
      max150Rule: [(v) => (v || "").length <= 150 || "Max Length of 150 character", (v) => !!v || "Field is required"],
      max1000Rule: [(v) => (v || "").length <= 1000 || "Max Length of 1000 character", (v) => !!v || "Field is required"],
      fileRules: [
        (files) => !files || !files.some((file) => file.size > 10e5) || "File size should be less than 10 MB!",
        (v) => !!v || "Field is required",
      ],
      bugHeaders: [
        { text: "Ticket Number", align: "start", value: "ticket_number", class: "primary customwhite--text" },
        { text: "Title", align: "start", value: "title", class: "primary customwhite--text" },
        { text: "Severity", value: "severity", class: "primary customwhite--text" },
        { text: "Status", value: "status", class: "primary customwhite--text" },
        { text: "Created Date", value: "cdate", class: "primary customwhite--text" },
        { text: "Schedule Completion Date", value: "sch_completion_date", class: "primary customwhite--text" },
        { text: "Actions", value: "actions", class: "primary customwhite--text" },
      ],
      displayTextArray: [],
      sortBy: "issue_id",
    };
  },
  async mounted() {
    this.getUserIssueDetails();
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.url = "";
      this.searchBugs = "";
      this.uploadFileName = "";
      this.issueTitle = "";
      this.issueDescription = "";
      this.totalRecords = 0;
      this.bugDialog = false;
      this.getUserIssueDetails();
    },
    //Get Issue/Bug list
    async getUserIssueDetails() {
      this.bugData = [];
      this.totalRecords = 0;
      let pass = 1;
      let issueObj = {
        UserId: parseInt(this.userId),
        pass: parseInt(pass),
      };
      let showMessage = false;
      let issueTrackerData = await issueService.postIssueTracker("post", issueObj, showMessage);
      if (issueTrackerData !== null && issueTrackerData !== undefined && issueTrackerData.message !== "NA") {
        this.bugData = issueTrackerData?.map((obj) => {
          return {
            ...obj,
            cdate: Utility.displayDateFormat(obj.cdate),
            sch_completion_date: Utility.displayDateFormat(obj.sch_completion_date),
          };
        });
        this.totalRecords = this.bugData.length;
      }
    },
    //Get Update Status
    async getUpdateStatus() {
      let issueObj = {
        UserId: parseInt(this.userId),
        pass: 11,
      };
      let showMessage = false;
      let data = await issueService.postIssueTracker("post", issueObj, showMessage);
      if (data !== null && data !== undefined && data.message !== "NA") {
        this.updateStatusData = data;
      }
    },
    //Update Status Change
    updateStatusChange() {
      if (this.selectedUpdatedStatus !== "" && this.selectedUpdatedStatus !== undefined) {
        this.showNewNotes = true;
        this.userNotes = "";
      }
    },
    async submitIssue() {
      if (this.$refs.userNotesForm.validate()) {
        let issueObj = {
          UserId: parseInt(this.userId),
          pass: 5,
          issue_id: this.issueTrackerData[0]?.issue_id,
          comments: this.userNotes,
          status: this.selectedUpdatedStatus,
          issue_type_id: this.issueTrackerData[0]?.issue_type_id,
          description: this.issueTrackerData[0]?.description,
        };
        let showMessage = true;
        let issueTrackerData = await issueService.postIssueTracker("post", issueObj, showMessage);
        if (issueTrackerData.Result[0]) {
          this.closeTicketDetails();
          this.resetFunction();
        }
      }
    },
    closeTicketDetails() {
      this.changeBugStatusDialog = false;
      this.userNotes = "";
      this.showNewNotes = false;
      this.selectedUpdatedStatus = "";
    },
    //Close the popup
    //Upload Screenshots button click event
    uploadFiles() {
      if (this.uploadFileName.length > 3) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Only two files are allowed",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
      }
    },
    //Change event of the upload
    onChange(e) {
      this.files = e.target.files || e.dataTransfer.files;
      if (!this.files.length) {
        this.dragging = false;
        return;
      } else {
        this.noFiles = false;
        if (this.files.length > 3) {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Max 3 files can be uploaded.",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.noFiles = true;
          this.dragging = false;
          this.files = "";
        }
        for (let i = 0; i < this.files.length; i++) {
          this.createFile(this.files[i]);
        }
      }
    },
    //Checking file details
    createFile(file) {
      if (file.size > 15000000) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "File size is more than 15MB",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.noFiles = true;
        this.dragging = false;
        return;
      }
      this.file = file;
      this.dragging = false;
      this.fileList.push(file);
    },
    //Removing dragged file
    removeFile(name) {
      this.fileList = this.fileList.filter((x) => x.name !== name);
      if (!this.fileList.length > 0) {
        this.noFiles = true;
        this.file = "";
        this.dragging = false;
      }
    },
    // Issue Details
    async issueDetails(item) {
      this.$router.push({
        name: "reportIssueDetails",
        params: {
          issueId: btoa(item.issue_id.toString()),
        },
      });
    },
    //Close the popup
    closeDialog() {
      this.issueTitle = "";
      this.url = "";
      this.removeFile();
      this.issueDescription = "";
      this.uploadFileName = "";
      this.$refs.newIssueForm.resetValidation();
      this.bugDialog = false;
    },
    async deleteFeedback() {
      let issueObj = {
        UserId: parseInt(this.userId),
        issue_id: this.issueId,
        pass: 6,
      };
      let showMessage = true;
      await issueService.postIssueTracker("post", issueObj, showMessage);
      this.showDeleteDialog = false;
      this.getUserIssueDetails();
    },
    onClickDeleteIcon(issueId) {
      this.showDeleteDialog = true;
      this.issueId = issueId;
    },
    onClickReportIssue() {
      this.showFeedbackForm = true;
    },
    closeFeedbackDialog() {
      this.showFeedbackForm = false;
      this.getUserIssueDetails();
    },
  },
  components: {
    breadcrumbComp,
    DisplayTextData,
    FeedbackForm,
  },
};
